module.exports = __webpack_public_path__ + "img/8792df1.jpg";